export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["UI_CONTENT_AWARENESS"] = "UI_CONTENT_AWARENESS";
    FeatureFlag["UI_SDK_CAMERA_CONTROL"] = "UI_SDK_CAMERA_CONTROL";
})(FeatureFlag || (FeatureFlag = {}));
//# sourceMappingURL=StateResponseBody.js.map